import { isValid } from "date-fns";
import { isMoreThanOneHourUntil } from "../../../utils.js";
export const getRenewAtError = (contract, errors) => {
    const dateString = contract.renew_at?.trim();
    if (!dateString)
        return errors;
    const parsed = new Date(dateString);
    if (!isValid(parsed)) {
        errors.renew_at = errors.renew_at ?? [];
        errors.renew_at.push("Ugyldig datoformat for kjøredato.");
        return errors;
    }
    if (!isMoreThanOneHourUntil(parsed, new Date())) {
        errors.renew_at = errors.renew_at ?? [];
        errors.renew_at.push("Kjøredatoen har passert, må være minst én time frem i tid.");
    }
    return errors;
};
